import { Button, Input } from '@material-tailwind/react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { FiSearch } from 'react-icons/fi'
import { useSearchParams } from 'react-router-dom'
import { FilterPopover } from '@/shared/components/filter-popover'
import DebouncedInput from '@/shared/components/debounced-input';
import { AccreditationSelector, ContractSelector, StatusSelector } from '@/shared/selectors'

export const AssetFilter = () => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()

  const handleSearch = (name, value) => {
    if (value === '' || value === null || value === undefined) {
      searchParams.delete(name);
    } else {
      searchParams.set(name, value);
      searchParams.set('page', 1);
    }
    setSearchParams(searchParams)
  };

  const handleInputSearch = (value) => {
    handleSearch('q', value);
  };
  
  const cleanSearchParams = () => {
    searchParams.delete('q')
    searchParams.delete('by_contract_id')
    searchParams.delete('by_status')
    searchParams.delete('by_accredited')
    setSearchParams(searchParams)

    setSearchParams(prevParams => new URLSearchParams(prevParams))
  }
  
  return (
    <div className='flex gap gap-3'>
      <div>
        <DebouncedInput
          name='q'
          icon={<FiSearch />}
          label={t('asset.searcher.label')}
          onChange={handleInputSearch}
          value={searchParams.get('q') || ''}
          className='w-full sm:w-80'
        />
      </div>
      <FilterPopover>
        <div className='grid gap gap-4'>
          <div className='grid gap gap-2'>
            <ContractSelector
              value={Number(searchParams.get('by_contract_id'))}
              onChange={(option) =>
                handleSearch('by_contract_id', option?.value)
              }
            />
          </div>
          <div className='grid gap gap-2'>
            <StatusSelector
              onChange={({ value }) =>
                handleSearch('by_status', value)
              }
              value={searchParams.get('by_status') || null}
            />
          </div>
          <div className='grid gap gap-2'>
            <AccreditationSelector
            onChange={({ value }) =>
                handleSearch('by_accredited', value)
              }
              value={searchParams.get('by_accredited') || null}
            />
          </div>
          <div className='flex justify-center mt-10'>
            <Button
              type='button'
              className='bg-color-white text-red-600 border-solid border-2 border-red-200 p-2'
              onClick={cleanSearchParams}
            >
              {t('filters.delete')}
            </Button>
          </div>
        </div>
      </FilterPopover>
    </div>
  )
}

AssetFilter.propTypes = {
  open: PropTypes.bool,
  handler: PropTypes.func
}
